import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ColorService } from '@services/utils/color.service';

@Component({
	selector: 'lead-source-color',
	template: require('./lead-source-color.html')
})
export class LeadSourceColorComponent implements OnInit {
	@Input() color: string;
	// -100 to 0 is darkened
	// 0 to 100 is lighten
	@Input() borderShadePercentage = -20;

	borderColor: string;

	constructor(private colorService: ColorService) {}

	ngOnInit(): void {
		this.changeBorderColor();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes.color.isFirstChange() && changes.color.currentValue) {
			this.changeBorderColor();
		}
	}

	private changeBorderColor(): void {
		if (this.color) {
			this.borderColor = this.colorService.shadeColor(
				this.color,
				this.borderShadePercentage
			);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/components/common/lead-source-color/lead-source-color.ts